import e from"@emotion/styled";import{setFontSize as t,setColor as i,setRadius as l}from"../../utils/generateStyles.js";const p=e.div`
  label: input-file-root;
  height: 48px;
  color: #3399ff;
  background-color: #eaf5ff;
  border: 1px dashed #cce5ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${()=>t("sm")}
  position: relative;
`,n=e.input`
  label: input-file;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 1;
  top: 0;
  right: 0;
  position: absolute;
  cursor: pointer;
`,a=e.span`
  label: input-file-name;
  direction: ltr;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 15px;
  width: 60%;
  text-align: center;
`,o=e.div`
  label: input-file-result-wrapper;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  ${()=>i("gray-140","color")}
`,r=e.img`
  label: input-file-result-image;
  width: 100%;
  height: 250px;
  object-fit: contain;
  ${()=>l("lg")}
`,s=e.div`
  label: input-file-result-button-wrapper;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 8px;
  margin-top: 15px;
`;export{n as InputFileInputStyled,a as InputFileNameStyled,s as InputFileResultButtonWrapperStyled,r as InputFileResultImageStyled,o as InputFileResultWrapperStyled,p as InputFileRootStyled};
